import SQLite, { DatabaseParams } from 'react-native-sqlite-storage';

export const OFFLINE_DATABASE_NAME = 'exhale_offline.db';
export const OFFLINE_DATABASE_VERSION = 12;
export const OFFLINE_DATABASE_LOCATION = 'default';

let sqliteConfigured = false;

export function configureOfflineSQLite(): void {
  if (sqliteConfigured) {
    return;
  }

  SQLite.DEBUG(false);
  SQLite.enablePromise(true);
  sqliteConfigured = true;
}

export async function openOfflineDatabase(
  params: Partial<DatabaseParams> = {}
): Promise<SQLite.SQLiteDatabase> {
  configureOfflineSQLite();

  return SQLite.openDatabase({
    name: OFFLINE_DATABASE_NAME,
    location: OFFLINE_DATABASE_LOCATION,
    createFromLocation: undefined,
    ...params,
  });
}
